// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__SNKRN","searchInput":"SearchBar_searchInput__HfVlM"};